import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTecRmi} from "../../../contexts/TecRmiContext";
import Breadcrumb from "../../Breadcrumb";
import PrintButton from "../PrintButton";
import TreeMenuNew from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import {mapWorkStepToItem, WorkStepLabel, workStepName} from "../Times/Times";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import WorkTimeMultiplier from "../WorkTimeMultiplier";
import WorkStep from "../Times/WorkStep";
import {isEmpty} from "lodash";
import Icon from "../../../componentsReusable/Icon";
import minutesToHours from "../../../utils/minutesToHours";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";

const LinkedWorkPositions = props => {
  const { getApiPrimaryParams, workTimeMultiplier } = useTecRmi()
  const [crumbs, setCrumbs] = useState([])
  const [workPositions, setWorkPositions] = useState(props.workPositions)

  useDidMountEffect(() => {
    apiUser.tecRmi.times.workStepsMulti({
      ...getApiPrimaryParams(),
      kindOfWorkTime: 0,
      bodyQualColId: props.bodyQualColId,
      items: workPositions.map(workPosition => ({
        korId: workPosition.KorId,
        itemMpId: workPosition.ItemMpId,
      })),
    })
      .then(res => {
        setWorkPositions(workPositions => {
          workPositions = workPositions.map(workPosition => {
            workPosition.workSteps = res.data
              .filter(workStep => workStep.ItemMpId === workPosition.ItemMpId && workStep.KorId === workPosition.KorId)
              .map(workStep => {
                workStep.WorkTimeDefault = workStep.WorkTime
                workStep.WorkTime = workStep.WorkTime * workTimeMultiplier

                return mapWorkStepToItem(workStep, workTimeMultiplier)
              })

            return workPosition
          })

          return [
            ...workPositions
          ]
        })
      })
  })

  useAfterUpdateEffect(() => {
    setWorkPositions(workPositions => {
      workPositions = workPositions.map(workPosition => {
        workPosition.workSteps = workPosition.workSteps
          .map(workStep => {
            workStep.WorkTime = workStep.WorkTimeDefault * workTimeMultiplier

            return workStep
          })

        return workPosition
      })

      return [
        ...workPositions
      ]
    })
  }, [workTimeMultiplier])

  const getMappedItems = () => {
    return workPositions.map(workPosition => {
      const itemMpId = `${workPosition.ItemMpId}-${workPosition.KorId}`
      let ret

      if(workPosition?.workSteps?.length === 1){
        const workStep = workPosition?.workSteps[0]
        const id = `${itemMpId}-${workStep.WorkId}`

        ret = {
          _type: 'workStep',
          _data: workStep,
          id,
          key: 'workStep' + workStep.WorkId,
          path: props.pathPrefix + '/' + id,
          label: <WorkStepLabel workStep={workStep} />,
          breadcrumbPathName: workStepName(workStep),
          component: WorkStep,
          componentProps: {
            bodyForTimes: props.bodyQualColId,
            workStep,
          },
        }
      }else{
        const key = 'itemMp' + workPosition.ItemMpId + 'KorId' + workPosition.KorId
        const name = workStepName(workPosition)

        ret = {
          _type: 'itemMp',
          id: itemMpId,
          key,
          path: props.pathPrefix + '/' + itemMpId,
          loading: isEmpty(workPosition?.workSteps),
          label: <span>
                <span className="text-secondary">{
                  isEmpty(workPosition?.workSteps)
                    ? <i className="fas fa-spin fa-spinner px-2" />
                    : <Icon className="fas fa-info-circle px-1" tooltip="Możliwy wybór" />
                }</span>
                <span className="ml-2">{name}</span>
              </span>,
          breadcrumbPathName: name,
          items: workPosition?.workSteps?.map(workStep => {
            const name = workStepName(workStep)

            return {
              _type: 'workStep',
              _data: workStep,
              id: workStep.WorkId,
              key: 'workStep' + workStep.WorkId,
              path: props.pathPrefix + '/' + [itemMpId, workStep.WorkId].join('/'),
              label: <span>
                    <span className="text-secondary">{minutesToHours(workStep.WorkTime, false, 2)}</span>
                    <span className="ml-2">{name}</span>
                  </span>,
              breadcrumbPathName: name,
              component: WorkStep,
              componentProps: {
                bodyForTimes: props.bodyQualColId,
                workStep,
              },
            }
          }) || [],
        }
      }

      return ret
    })
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <Breadcrumb
          crumbs={[
            {
              name: <i className="fas fa-home" />,
              path: props.pathPrefix,
            },
            ...crumbs
          ]}
        />

        <div className="d-flex flex-row flex-nowrap align-items-center justify-content-end ml-auto">
          <WorkTimeMultiplier />
          <PrintButton />
        </div>
      </div>
      <TreeMenuNew
        actives={props.params}
        items={getMappedItems()}
        onCrumbsChanged={setCrumbs}
      />
    </div>
  );
};

LinkedWorkPositions.propTypes = {
  bodyQualColId: PropTypes.number.isRequired,
};

export default LinkedWorkPositions;